import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as productCallsActionCreators from '../../../../actionCreators/product';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import * as commonCallsActionCreators from '../../../../actionCreators/common';
import './CLPrescription.scss';

class CLprescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactPrescription: true,
      itemIndex: null,
    };
    this.showErrorBox = 0;
  }
  componentDidUpdate(prevProps) {
    const { isContactPrescription, inValidPres, isJitProduct, isNonJitPowerValidated } = this.props;
    const prescValidCondition =
      isContactPrescription !== prevProps.isContactPrescription && isContactPrescription !== null;
    if (
      (isJitProduct && prescValidCondition && inValidPres) ||
      (!isJitProduct &&
        prescValidCondition &&
        ((!inValidPres && !isNonJitPowerValidated) || (inValidPres && isNonJitPowerValidated)))
    ) {
      this.setClPrescValid(false);
    }
  }

  setClPrescValid = isValid => {
    this.setState({ contactPrescription: isValid });
  };

  getUrlQueryPackage = () => {
    const query = this.props.location.search.substr(1);
    const result = {};
    query.split('&').forEach(param => {
      const item = param.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result.package;
  };

  select = (savedData, index, event) => {
    this.showErrorBox = index;
    event.preventDefault();
    window.ReactPixel.default.track('AddToCart', {
      content_type: 'product',
      content_ids: [this.props.sidebarContent.id],
      value: this.props.sidebarContent.prices[1].price.toFixed(2),
      content_name: this.props.sidebarContent.fullName,
      currency: 'INR',
    });
    let data = {};
    data = {
      productId: this.props.sidebarContent.id,
      quantity: savedData.left.boxes + savedData.right.boxes,
      prescription: {
        left: savedData.left,
        right: savedData.right,
      },
    };
    if (this.props.leftBoxesQty > 0) {
      data.prescription.left.boxes = this.props.leftBoxesQty + '';
    } else {
      data.prescription.left = undefined;
    }
    if (this.props.rightBoxesQty > 0) {
      data.prescription.right.boxes = this.props.rightBoxesQty + '';
    } else {
      data.prescription.right = undefined;
    }
    data.quantity = Number(this.props.rightBoxesQty) + Number(this.props.leftBoxesQty);
    this.props.selectedPrescription(data);
    this.setState({
      contactPrescription: true,
      itemIndex: index,
    });
    if (this.props.isChecked && this.props.sidebarContent.crossSells.length)
      data.relatedProductIds = [this.props.sidebarContent.crossSells[0].id];
    if (savedData.right.sph?.indexOf('call') === -1 || savedData.left.sph?.indexOf('call') === -1) {
      this.setState({ contactPrescription: true });
      const powerData = {
        powerOptionList: [],
      };
      Object.keys(savedData.right).forEach(key => {
        powerData.powerOptionList.push({
          type: `Right ${key.toString().toUpperCase()}`,
          value: key === 'boxes' ? this.props.rightBoxesQty + '' : savedData.right[key],
          price: 0,
        });
      });
      Object.keys(savedData.left).forEach(key => {
        powerData.powerOptionList.push({
          type: `Left ${key.toString().toUpperCase()}`,
          value: key === 'boxes' ? this.props.leftBoxesQty + '' : savedData.left[key],
          price: 0,
        });
      });
      if (this.props.isJitProduct) {
        this.props.productCallsAction.isContactPrescValid(powerData, this.props.sidebarContent.id);
      } else {
        this.props.productCallsAction.isContactPrescValid(data, null);
      }
    } else {
      this.props.cartCallsAction.addToCart(data, this.getUrlQueryPackage());
      this.props.commonCallsAction.toggleCart(true, 'add');
      this.props.modelHide(false);
    }
  };

  render() {
    const { isContactPrescription, isJitProduct, inValidPres, isNonJitPowerValidated, dataLocale } =
      this.props;
    const {
      USER,
      NO_SAVED_PRESCRIPTION_FOUND,
      POWERTYPE,
      RIGHT_EYE,
      EYE,
      LEFT_EYE,
      SPHERICAL,
      CYLINDRICAL,
      AXIS,
      SELECT,
      PRESCRIPTION_TYPE,
      CALL_EMAIL,
    } = dataLocale; // BOXES
    return (
      <div className="clPrescriptionTab">
        {this.props.isLoaded &&
          this.props.savedPrescription &&
          this.props.savedPrescription.result.length > 0 && (
            <div className="use-saved-panel-inner">
              {this.props.savedPrescription &&
                this.props.savedPrescription.result.map((data, index) => {
                  return (
                    <div key={index} className="margin-b10 item-row">
                      {this.state.contactPrescription === false &&
                        this.showErrorBox === index &&
                        inValidPres && (
                          <div className="alert alert-danger user-saved-isvalid margin-b5 padding-5">{`${
                            isContactPrescription.code
                              ? `${isContactPrescription.error}`
                              : `${isContactPrescription.message}`
                          }`}</div>
                        )}
                      {!isNonJitPowerValidated &&
                        this.showErrorBox === index &&
                        !isJitProduct &&
                        isContactPrescription && (
                          <ul
                            className="alert alert-danger user-saved-isvalid"
                            style={{
                              padding: '5px',
                              paddingLeft: '10px',
                              width: '99.5%',
                              marginLeft: '.25%',
                              marginBottom: '5px',
                            }}
                          >
                            {isContactPrescription.result[0].leftQuantityValidationError && (
                              <li className="bullet-list">{`${LEFT_EYE}: ${isContactPrescription.result[0].leftQuantityValidationError}`}</li>
                            )}
                            {isContactPrescription.result[0].rightQuantityValidationError && (
                              <li className="bullet-list">{`${RIGHT_EYE}: ${isContactPrescription.result[0].rightQuantityValidationError}`}</li>
                            )}
                          </ul>
                        )}
                      {data.hasOwnProperty('left') &&
                        data.left.sph !== 'Call Me/Email Me for Power' &&
                        data.hasOwnProperty('right') &&
                        data.right.sph !== 'Call Me/Email Me for Power' && (
                          <div>
                            <div className="col-lg-12 col-md-12 col-sm-12 saved-heading">
                              <div className="col-lg-6 col-md-6 col-sm-6 saved-heading-one text-left">
                                {USER}: {data.userName && data.userName.replace(/_/g, ' ')}
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 saved-heading-two text-right">
                                {POWERTYPE}: {data.powerType && data.powerType.replace(/_/g, ' ')}
                              </div>
                            </div>
                            <div className="add-power-tabel add-power-column power-colmn-five">
                              <ul className="power-submit-panel">
                                <li className="pouwer-submit-head">{EYE}</li>
                                <li className="pouwer-submit-head text-uppercase">{RIGHT_EYE}</li>
                                <li className="pouwer-submit-head text-uppercase">{LEFT_EYE}</li>
                              </ul>
                              <div className="power-block power-submit-panel power-submit-default">
                                <ul className="parent-list">
                                  <li className="pouwer-submit-head text-uppercase">{SPHERICAL}</li>
                                  <li>{data.right.sph ? data.right.sph : '-'}</li>
                                  <li>{data.left.sph ? data.left.sph : '-'}</li>
                                </ul>
                              </div>
                              <div className="power-block power-submit-panel power-submit-default">
                                <ul className="parent-list">
                                  <li className="pouwer-submit-head text-uppercase">
                                    {CYLINDRICAL}
                                  </li>
                                  <li>{data.right.cyl ? data.right.cyl : '-'}</li>
                                  <li>{data.left.cyl ? data.left.cyl : '-'}</li>
                                </ul>
                              </div>
                              <div className="power-block power-submit-panel power-submit-default">
                                <ul className="parent-list">
                                  <li className="pouwer-submit-head text-uppercase">{AXIS}</li>
                                  <li>{data.right.axis ? data.right.axis : '-'}</li>
                                  <li>{data.left.axis ? data.left.axis : '-'}</li>
                                </ul>
                              </div>
                              {/* <div className="power-block power-submit-panel power-submit-default">
                                                <ul className="parent-list">
                                                    <li className="pouwer-submit-head text-uppercase">{BOXES}</li>
                                                    <li>{data.right.boxes ? data.right.boxes : '-'}</li>
                                                    <li>{data.left.boxes ? data.left.boxes : '-'}</li>
                                                </ul>
                                            </div> */}
                            </div>
                            <button
                              className="saved-button text-capitalize"
                              type="button"
                              onClick={ev => this.select(data, index, ev)}
                            >
                              {this.props.isSpinner && this.state.itemIndex === index ? (
                                <i className="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                              ) : (
                                SELECT
                              )}
                            </button>
                          </div>
                        )}
                      {data.hasOwnProperty('left') &&
                        data.left.sph === 'Call Me/Email Me for Power' &&
                        data.hasOwnProperty('right') &&
                        data.right.sph === 'Call Me/Email Me for Power' && (
                          <div>
                            <div className="col-lg-12 col-md-12 col-sm-12 no-padding">
                              <div className="col-lg-12 col-md-12 col-sm-12 saved-heading">
                                <div className="col-lg-6 col-md-6 col-sm-6 saved-heading-one text-left">
                                  {USER}: {data.userName.replace(/_/g, ' ')}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 saved-heading-two text-right">
                                  {POWERTYPE}: {data.powerType.replace(/_/g, ' ')}
                                </div>
                              </div>
                            </div>
                            <div className="submit-calling" style={{ clear: 'both' }}>
                              <span className="exclaimation">!</span>
                              <strong>{PRESCRIPTION_TYPE}:</strong> {CALL_EMAIL}
                            </div>
                            <button
                              className="saved-button text-lowercase"
                              type="button"
                              onClick={ev => this.select(data, null, ev)}
                            >
                              {SELECT}
                            </button>
                          </div>
                        )}
                    </div>
                  );
                })}
            </div>
          )}
        {!this.props.isLoaded && (
          <div className="text-center cl-spinner">
            <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
          </div>
        )}
        {this.props.isLoaded &&
          this.props.savedPrescription &&
          this.props.savedPrescription.result.length === 0 && (
            <div className="use-saved-panel-inner no-saved-prescription text-center">
              {NO_SAVED_PRESCRIPTION_FOUND}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  savedPrescription: state.product.savedPrescription,
  isLoaded: state.product.isCLSavedPresLoaded,
  loading: state.product.loading,
  inValidPres: state.product.inValidPres,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    productCallsAction: bindActionCreators(productCallsActionCreators, dispatch),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CLprescription);
